import { AxiosResponse } from 'axios';
import { JSX, useMemo } from 'react';
import { ACTIONS, useAuth } from './auth';
import { api } from '@/services/api';

export const AxiosInterceptorProvider = (props: {
  children: React.JSX.Element;
}): JSX.Element => {
  const { dispatch } = useAuth();

  useMemo(() => {
    api.interceptors.response.use(
      (response: AxiosResponse) => {
        return response;
      },
      function (error) {
        if (Number(error.response.status) === 401) {
          console.log('Unauthorized request:', error.config.url); // Log the URL that returned 401
          dispatch({
            type: ACTIONS.LOGOUT,
          });
          localStorage.clear();
          return Promise.reject(error);
        }

        return Promise.reject(error);
      },
    );
  }, [dispatch]);
  return props.children;
};
